

















































































































































































































import { Component, Mixins } from "vue-property-decorator";
import swal from "sweetalert";
import Api from "@/api";
import { AxiosResponse } from "axios";

import FormErrorsMixin from "@/mixins/FormErrors";
import BaseMixin from "@/mixins/BaseMixin";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import NavigationTabs from "@/components/Customers/Customer/NavigationTabs.vue";
import Error404 from "@/components/Common/Error404.vue";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { IParticipant } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    NavigationTabs,
    Error404,
    DatePicker
  }
})
export default class CustomerParticipant extends Mixins(
  FormErrorsMixin,
  BaseMixin
) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "customer_id",
    "gender",
    "first_name",
    "last_name",
    "email",
    "birthdate"
  ];
  private noDataExist = false;
  private originalFirstName: string | null = null;
  private originalLastName: string | null = null;
  private dateFormat = "DD.MM.YYYY";
  private selectedParticipant: IParticipant = {
    gender: null,
    title: null,
    first_name: null,
    last_name: null,
    email: null,
    birthdate: null
  };
  private selectedCustomerId: string | null = null;
  private selectedParticipantId: string | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedCustomerId = vm.$route.params.customer_id;
      vm.selectedParticipantId = vm.$route.params.participant_id;
      if (
        typeof vm.selectedCustomerId !== "undefined" &&
        vm.selectedCustomerId !== null &&
        typeof vm.selectedParticipantId !== "undefined" &&
        vm.selectedParticipantId !== null
      ) {
        if (vm.$route.query.participant_created === "true") {
          swal("Success!", "The participant was created.", "success").then(
            () => {
              window.history.pushState(
                {},
                document.title,
                window.location.pathname
              );
            }
          );
        }
        vm.getParticipant(() => {
          //
        });
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (
      typeof this.selectedCustomerId !== "undefined" &&
      this.selectedCustomerId !== null &&
      typeof this.selectedParticipantId !== "undefined" &&
      this.selectedParticipantId !== null
    ) {
      this.getParticipant(() => {
        //
      });
    }
    next();
  }

  private createOrUpdateParticipant(): void {
    if (this.selectedParticipantId == null) {
      this.createParticipant();
    } else {
      this.updateParticipant();
    }
  }

  private createParticipant(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("participants");

    Api()
      .post(endpoint, {
        ...this.selectedParticipant,
        birthdate: this.convertDate(this.selectedParticipant.birthdate),
        customer_id: this.selectedCustomerId
      })
      .then((response: AxiosResponse) => {
        this.selectedParticipantId = response.data.data.id;
        this.$router.push({
          name: "CustomerParticipantDetails",
          params: {
            customer_id: `${this.selectedCustomerId}`,
            participant_id: `${this.selectedParticipantId}`
          },
          query: { participant_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#participant-last-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getParticipant(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "participants/" + this.selectedParticipantId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedParticipant = response.data.data;
        this.selectedParticipant.birthdate =
          response.data.data.birthdate !== null
            ? new Date(response.data.data.birthdate)
            : new Date();
        if (this.selectedParticipant.first_name) {
          this.originalFirstName = this.selectedParticipant.first_name;
        }
        if (this.selectedParticipant.last_name) {
          this.originalLastName = this.selectedParticipant.last_name;
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateParticipant(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "participants/" + this.selectedParticipantId
    );

    Api()
      .put(endpoint, {
        ...this.selectedParticipant,
        birthdate: this.convertDate(this.selectedParticipant.birthdate),
        customer_id: this.selectedCustomerId
      })
      .then(() => {
        this.getParticipant(() => {
          //
        });
        swal({
          title: "Success!",
          text: "The participant was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#participant-last-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteParticipant() {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The participant will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "participants/" + this.selectedParticipantId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "CustomerParticipants",
              query: { participant_deleted: "true" }
            });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete participants.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }
}
